/* eslint-disable import/no-mutable-exports */
var monitor = {
  init: function () {
  
  }
};

export default monitor;